export default class Attribute {
  constructor(array, itemSize) {
    this.itemSize = itemSize;
    this.setArray(array);
    this.dynamic = false;
  }

  setArray(array) {
    this.count = array !== undefined ? array.length / this.itemSize : 0;
    this.array = array;
    return this;
  }

  clone() {
    return new Attribute(this.array, this.itemSize);
  }
}
